import { render, staticRenderFns } from "./SelectorChecklistLaborProtection.vue?vue&type=template&id=198bc95f&"
import script from "./SelectorChecklistLaborProtection.vue?vue&type=script&lang=ts&"
export * from "./SelectorChecklistLaborProtection.vue?vue&type=script&lang=ts&"
import style0 from "./SelectorChecklistLaborProtection.vue?vue&type=style&index=0&id=198bc95f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports